import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      ¿Alguna vez imaginaron leer un diario escrito por un gorrión? Oswaldo Díaz Díaz nos ofrece ese privilegio y nos
      advierte: “Preguntaréis: Cómo es posible que un gorrión —por más nombres que tenga— escriba su diario, como lo
      hacen los artistas y las colegialas? Pero hay una dificultad mayor: es saber cómo he hecho yo para conseguir este
      diario, para entenderlo y descifrarlo y para copiarlo luego en el idioma de los niños. No entraré a explicároslo
      porque estas cosas sólo suceden en los libros de cuentos”.
    </p>
    <p className="content justified">
      El anterior es el segundo párrafo del cuento y allí Díaz Díaz nos da muchas pistas sobre su concepción de la
      literatura infantil. Nos habla del mundo de los cuentos, del idioma de los niños y de las situaciones
      aparentemente absurdas que solo pueden suceder en la fantasía.
    </p>
    <p className="content justified">
      La literatura infantil es entonces un lugar especial, único, donde ocurren cosas que no podrían pasar en otros
      escenarios y que, además, requiere de un lenguaje especial. También nos invita a conocer con curiosidad aquello
      que un pequeño gorrión, o copetón como él lo llama, dejó registrado en su diario.
    </p>
  </div>
);

export const bottomParagraph = <div className="bottomParagraph"></div>;

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Pico Duro y su historia familiar</h3>
      <p className="content justified">
        “Diré ante todo que mi nombre es Pico Duro”: así se presenta este pajarito de plumas pardas y grises, de pies
        pequeños y rosados, de ojos brillantes y negros, y de pico muy distinguido. Poco a poco el gorrión habla de su
        antepasados, nos cuenta que está casado con Plumón y que tienen un hijo llamado Pico Fino.
      </p>
      <p className="content justified">
        Buena parte del diario se desarrolla a partir de las historias de Pico Fino: cómo llegó al mundo siendo un
        desplumado y débil polluelo, la manera violenta, pero efectiva en que aprendió a volar, y su casamiento con
        Pluma Blanca.
      </p>
      <p className="content justified">
        Pico Duro comparte su preocupación porque hay un Gato y un niño malo llamado Caifás. Ambos han estado muy
        pendientes de los vuelos de adiestramiento de Pico Fino.
      </p>
      <p className="content justified">
        “Ha sido terrible. Hoy he tenido la mayor pena de mi existencia y Plumón está inconsolable”, escribe Pico Duro
        el 30 de agosto. Caifás tomó uno de los huevos del nido de Pico Fino y de Pluma Blanca, y el Gato se llevó a
        Pico Fino.
      </p>
      <p className="content justified">
        Desde aquel día, empiezan a suceder varias desgracias entre las que se encuentran la muerte de su amado polluelo
        y de Pluma Blanca, torrenciales lluvias y la destrucción del nido donde vivían Pico Duro y Plumón.
      </p>
      <p className="content justified">
        Al final, Pico Duro, con toda la fe y la esperanza de un mañana mejor, se sobrepone junto a su esposa y planea
        un futuro mejor, quiere construir un nuevo nido y empollar nuevos descendientes.
      </p>
    </div>
    <div className="sectionReview">
      <h3 className="review-title subtitle">La vida tal cual</h3>
      <p className="content justified">
        “Diario de un gorrión” es un cuento donde se condensa el ciclo de la vida, de la sucesión en el tiempo de las
        generaciones, de la creación de familias, de los momentos difíciles y de las pérdidas. Al final, el amor y la
        esperanza permiten seguir adelante.
      </p>
      <p className="content justified">
        Oswaldo Díaz Díaz, de una manera sutil y aparentemente inocente, nos muestra los momentos más crudos que hacen
        parte de la vida de cualquier ser, esa vida de múltiples facetas de las que nadie, ni siquiera los niños,
        resultan ajenos. Y las realidades no tan amables ni fáciles que también merecen ser mostradas.
      </p>
      <p className="content justified">
        Vemos entonces que, para Don Os, los niños son unos destinatarios a los que se les puede hablar de muchos temas:
        la muerte, los accidentes, la violencia. Y eso se puede hacer a través de los cuentos, con un lenguaje especial
        y cuidado, el mismo del que nos hablaba al comienzo de esta historia.
      </p>
    </div>
  </div>
);
